const HOME_CALENDAR_ENDPOINT = '/api/event-calendar';

function cleanText(value) {
  return String(value || '').replace(/\s+/g, ' ').trim();
}

function safeUrl(value) {
  try {
    const url = new URL(String(value || ''), window.location.origin);
    return ['http:', 'https:'].includes(url.protocol) ? url.toString() : '/apple-event-kalender/';
  } catch {
    return '/apple-event-kalender/';
  }
}

function formatDate(value) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Dato følger';
  return new Intl.DateTimeFormat('da-DK', { day: 'numeric', month: 'short' }).format(date);
}

function createCalendarEvent(event) {
  const title = cleanText(event?.title);
  if (!title) return null;
  const link = document.createElement('a');
  link.className = 'wla-home-v3__calendar-event';
  link.href = safeUrl(event.url || event.path);
  link.dataset.wlaInternalLink = '1';
  link.dataset.wlaInternalModule = 'home-calendar';
  link.dataset.wlaInternalPlacement = 'home_calendar_event';
  const time = document.createElement('time');
  time.dateTime = event.startDate || '';
  time.textContent = formatDate(event.startDate);
  const heading = document.createElement('strong');
  heading.textContent = title;
  const meta = document.createElement('span');
  meta.textContent = cleanText(event.statusLabel || event.confidenceLabel || event.confidence || 'Forventet');
  link.append(time, heading, meta);
  return link;
}

export async function initHomeCalendar() {
  const root = document.querySelector('[data-wla-home-calendar]');
  const list = root?.querySelector('[data-wla-home-calendar-list]');
  if (!root || !list) return;
  try {
    const response = await fetch(HOME_CALENDAR_ENDPOINT, { headers: { accept: 'application/json' } });
    if (!response.ok) return;
    const payload = await response.json();
    const events = (Array.isArray(payload?.upcoming) ? payload.upcoming : [])
      .slice(0, 5)
      .map(createCalendarEvent)
      .filter(Boolean);
    if (!events.length) return;
    list.replaceChildren(...events);
    const next = payload.upcoming[0];
    const nextTitle = document.querySelector('[data-wla-home-next-event]');
    const nextDate = document.querySelector('[data-wla-home-next-event-date]');
    if (nextTitle) nextTitle.textContent = cleanText(next.title);
    if (nextDate) nextDate.textContent = formatDate(next.startDate);
  } catch {}
}
